import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { PAYMENT, PROFILE } from 'services/consts';

const initialState = {
	otoPackageList: [],
	modulesList: [],
	selectedModule: null,
	loading: false,
	moduleDetailLoading: false
};

export const getOTOPackageList = createAsyncThunk('otoPackageList/fetchAll', async (_, { getState }) => {
	const { otoPackageList } = getState();
	if (otoPackageList.length > 0) {
		return otoPackageList;
	}

	const axiosPrivate = useAxiosPrivate();
	const response = await axiosPrivate.post(PAYMENT.GET_SUBSCRIPTION_PACKAGE_DETAILS);
	return response.data.packages;
});

export const getModulesList = createAsyncThunk('modulesList/fetchAll', async (_, { getState }) => {
	const { modulesList } = getState();
	if (modulesList?.length > 0) {
		return modulesList;
	}
	const axiosPrivate = useAxiosPrivate();
	const response = await axiosPrivate.post(PROFILE.GET_COMPANY_MODULES);

	return response.data;
});

export const getModuleBySlug = createAsyncThunk('moduleBySlug/fetchAll', async (slug) => {
	const axiosPrivate = useAxiosPrivate();
	const response = await axiosPrivate.post(PROFILE.GET_MODULE_BY_SLUG, { slug });
	return response.data;
});

export const getPackagesAndModules = createAsyncThunk('packagesAndModules/fetchAll', async (_, { dispatch }) => {
	const results = await Promise.all([dispatch(getModulesList(), dispatch(getOTOPackageList()))]);

	return {
		otoPackageList: results[0].data,
		modulesList: results[1].data
	};
});

const otoPackageList = createSlice({
	name: 'otoPackageList',
	initialState,
	reducers: {
		selectModule: (state, { payload }) => {
			state.selectedModule = payload;
		}
	},
	extraReducers: (builder) => {
		builder

			.addCase(getOTOPackageList.fulfilled, (state, { payload }) => {
				state.otoPackageList = payload;
			})

			.addCase(getModulesList.fulfilled, (state, { payload }) => {
				state.modulesList = payload;
			})

			.addCase(getModuleBySlug.pending, (state) => {
				state.moduleDetailLoading = true;
			})
			.addCase(getModuleBySlug.fulfilled, (state, { payload }) => {
				state.selectedModule = payload;
				state.moduleDetailLoading = false;
			})
			.addCase(getModuleBySlug.rejected, (state) => {
				state.moduleDetailLoading = false;
			})
			.addCase(getPackagesAndModules.pending, (state) => {
				state.loading = true;
			})
			.addCase(getPackagesAndModules.fulfilled, (state, { payload }) => {
				if (payload.otoPackageList) state.otoPackageList = payload.otoPackageList;
				if (payload.modulesList) state.modulesList = payload.modulesList;
				state.loading = false;
			})
			.addCase(getPackagesAndModules.rejected, (state) => {
				state.loading = false;
			});
	}
});

export const { selectModule } = otoPackageList.actions;
export default otoPackageList.reducer;
